import {
  fudaoAppService as service,
  FudaoEvent,
  FudaoApplicationServiceErrorName
} from 'langyan';
import router from '@/router/router';
import eventBus from '@/event-bus';

const subscribe = (event, handler) => {
  service.subscribeEventHandler(event, domainEvent => {
    log.tag('event', event).info(domainEvent);
    handler(domainEvent);
  });
};

export function subscribeFudaoEvents(commit, state, rootState, dispatch) {
  // 邀請 學生接受 老師取消 學生取消 無回應

  // 輔導狀態 ----------------------------------------------------------
  subscribe(FudaoEvent.FudaoStarted, domainEvent => {
    eventBus.$emit(FudaoEvent.FudaoStarted, domainEvent);

    let fudaoDto = domainEvent.body;
    commit('updateFudaoDto', fudaoDto);
    router.push({name: 'Fudao'});

    let chatUsername;
    if (rootState.profile.username === fudaoDto.student.Name) {
      chatUsername = fudaoDto.teacher.Name;
    } else {
      chatUsername = fudaoDto.student.Name;
    }
    dispatch('chat/switchChat', {username: chatUsername}, {root: true});
  });

  subscribe(FudaoEvent.FudaoStartFailed, domainEvent => {
    let message = domainEvent.body;
    eventBus.$emit(FudaoEvent.FudaoStartFailed, message);
  });

  subscribe(FudaoEvent.FudaoExtended, domainEvent => {
    eventBus.$emit(FudaoEvent.FudaoExtended, domainEvent);
    commit('updateFudaoDto', domainEvent.body);
  });

  subscribe(FudaoEvent.FudaoTimeUp, domainEvent => {
    eventBus.$emit(FudaoEvent.FudaoTimeUp, domainEvent);
  });

  subscribe(FudaoEvent.FudaoEnded, domainEvent => {
    eventBus.$emit(FudaoEvent.FudaoEnded, domainEvent);

    let fudaoId = domainEvent.body.id;
    let teacherId = domainEvent.body.teacher.Id;
    let studentId = domainEvent.body.student.Id;

    switch (domainEvent.body.status) {
      // status was defined in FudaoDefinition.ts
      // 結束時發生錯誤
      case 'AbnormalEnded':
        dispatch('alert/addWarn', '輔導結束時發生錯誤', {root: true});
        break;

      // 中斷
      case 'Interrupted':
        dispatch('alert/addWarn', '輔導中斷', {root: true});
        break;

      default:
        dispatch('alert/addInfo', '輔導結束', {root: true});
        if (rootState.userid === teacherId) {
          eventBus.$emit('fudao-evaluation-student', {fudaoId, teacherId, studentId});
        } else {
          eventBus.$emit('fudao-evaluation-teacher', {fudaoId, teacherId, studentId});
        }
    }

    commit('updateFudaoDto', {});
    commit('updateFudaoSession', {});
    router.push({name: 'Chats'});
  });

  // 邀請輔導 ----------------------------------------------------------
  subscribe(FudaoEvent.TeacherStartInvitationSent, domainEvent => eventBus.$emit(FudaoEvent.TeacherStartInvitationSent, domainEvent));
  subscribe(FudaoEvent.TeacherStartInvitationCanceled, domainEvent => eventBus.$emit(FudaoEvent.TeacherStartInvitationCanceled, domainEvent));
  subscribe(FudaoEvent.StudentStartInvitationReceived, domainEvent => eventBus.$emit(FudaoEvent.StudentStartInvitationReceived, domainEvent));
  subscribe(FudaoEvent.StudentStartInvitationAccepted, domainEvent => eventBus.$emit(FudaoEvent.StudentStartInvitationAccepted, domainEvent));
  subscribe(FudaoEvent.StudentStartInvitationRejected, domainEvent => eventBus.$emit(FudaoEvent.StudentStartInvitationRejected, domainEvent));
  subscribe(FudaoEvent.StudentStartInvitationNoResponse, domainEvent => eventBus.$emit(FudaoEvent.StudentStartInvitationNoResponse, domainEvent));

  // 結束輔導 ----------------------------------------------------------
  subscribe(FudaoEvent.TeacherEndInvitationSent, domainEvent => eventBus.$emit(FudaoEvent.TeacherEndInvitationSent, domainEvent));
  subscribe(FudaoEvent.TeacherEndInvitationCanceled, domainEvent => eventBus.$emit(FudaoEvent.TeacherEndInvitationCanceled, domainEvent));
  subscribe(FudaoEvent.StudentEndInvitationReceived, domainEvent => eventBus.$emit(FudaoEvent.StudentEndInvitationReceived, domainEvent));
  subscribe(FudaoEvent.StudentEndInvitationAccepted, domainEvent => eventBus.$emit(FudaoEvent.StudentEndInvitationAccepted, domainEvent));
  subscribe(FudaoEvent.StudentEndInvitationRejected, domainEvent => eventBus.$emit(FudaoEvent.StudentEndInvitationRejected, domainEvent));
  subscribe(FudaoEvent.StudentEndInvitationNoResponse, domainEvent => eventBus.$emit(FudaoEvent.StudentEndInvitationNoResponse, domainEvent));

  // 延長輔導 ----------------------------------------------------------
  subscribe(FudaoEvent.TeacherExtendInvitationSent, domainEvent => eventBus.$emit(FudaoEvent.TeacherExtendInvitationSent, domainEvent));
  subscribe(FudaoEvent.TeacherExtendInvitationCanceled, domainEvent => eventBus.$emit(FudaoEvent.TeacherExtendInvitationCanceled, domainEvent));
  subscribe(FudaoEvent.StudentExtendInvitationReceived, domainEvent => eventBus.$emit(FudaoEvent.StudentExtendInvitationReceived, domainEvent));
  subscribe(FudaoEvent.StudentExtendInvitationAccepted, domainEvent => eventBus.$emit(FudaoEvent.StudentExtendInvitationAccepted, domainEvent));
  subscribe(FudaoEvent.StudentExtendInvitationRejected, domainEvent => eventBus.$emit(FudaoEvent.StudentExtendInvitationRejected, domainEvent));
  subscribe(FudaoEvent.StudentExtendInvitationNoReponse, domainEvent => eventBus.$emit(FudaoEvent.StudentExtendInvitationNoReponse, domainEvent));


  // session
  subscribe(FudaoEvent.TeacherStartSessionInvitationCanceled, domainEvent => eventBus.$emit(FudaoEvent.TeacherStartSessionInvitationCanceled, domainEvent));
  subscribe(FudaoEvent.TeacherEndSessionInvitationCanceled, domainEvent => eventBus.$emit(FudaoEvent.TeacherEndSessionInvitationCanceled, domainEvent));
  subscribe(FudaoEvent.StudentStartSessionInvitationReceived, domainEvent => eventBus.$emit(FudaoEvent.StudentStartSessionInvitationReceived, domainEvent));
  subscribe(FudaoEvent.StudentStartSessionInvitationAccepted, domainEvent => eventBus.$emit(FudaoEvent.StudentStartSessionInvitationAccepted, domainEvent));
  subscribe(FudaoEvent.StudentStartSessionInvitationRejected, domainEvent => eventBus.$emit(FudaoEvent.StudentStartSessionInvitationRejected, domainEvent));
  subscribe(FudaoEvent.StudentStartSessionInvitationNoReponse, domainEvent => eventBus.$emit(FudaoEvent.StudentStartSessionInvitationNoReponse, domainEvent));
  subscribe(FudaoEvent.StudentEndSessionInvitationReceived, domainEvent => eventBus.$emit(FudaoEvent.StudentEndSessionInvitationReceived, domainEvent));
  subscribe(FudaoEvent.StudentEndSessionInvitationAccepted, domainEvent => eventBus.$emit(FudaoEvent.StudentEndSessionInvitationAccepted, domainEvent));
  subscribe(FudaoEvent.StudentEndSessionInvitationRejected, domainEvent => eventBus.$emit(FudaoEvent.StudentEndSessionInvitationRejected, domainEvent));
  subscribe(FudaoEvent.StudentEndSessionInvitationNoReponse, domainEvent => eventBus.$emit(FudaoEvent.StudentEndSessionInvitationNoReponse, domainEvent));
  subscribe(FudaoEvent.StudentStartFudaoSessionReceived, domainEvent => eventBus.$emit(FudaoEvent.StudentStartFudaoSessionReceived, domainEvent));

  subscribe(FudaoEvent.FudaoUserOnlineStatusChanged, domainEvent => eventBus.$emit(FudaoEvent.FudaoUserOnlineStatusChanged, domainEvent));
  subscribe(FudaoEvent.FudaoSessionInited, domainEvent => eventBus.$emit(FudaoEvent.FudaoSessionInited, domainEvent));
  subscribe(FudaoEvent.FudaoSessionNetworkQualityChanged, domainEvent => eventBus.$emit(FudaoEvent.FudaoSessionNetworkQualityChanged, domainEvent));
  subscribe(FudaoEvent.FudaoSessionFailed, domainEvent => eventBus.$emit(FudaoEvent.FudaoSessionFailed, domainEvent));

  subscribe(FudaoEvent.FudaoSessionStarted, domainEvent => {
    eventBus.$emit(FudaoEvent.FudaoSessionStarted, domainEvent);
    commit('updateFudaoSession', domainEvent.body);
  });

  subscribe(FudaoEvent.FudaoSessionEnded, domainEvent => {
    eventBus.$emit(FudaoEvent.FudaoSessionEnded, domainEvent);
    commit('updateFudaoSession', {});
  });


  subscribe(FudaoEvent.TeacherTimePassed, domainEvent => eventBus.$emit(FudaoEvent.TeacherTimePassed, domainEvent));

  // subscribe error event handler
  service.errorOccurred.addListener(FudaoApplicationServiceErrorName, error => {
    log.tag('event', FudaoApplicationServiceErrorName).error(error);
    dispatch('alert/addError', error.message, {root: true});
  });
}
